function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWaterDropFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.841 25.015c-2.266 0-4.55-1.533-4.55-4.96a1 1 0 112 0c0 1.881.93 2.96 2.55 2.96a1 1 0 110 2zm.63-20.334c-2.047 2.574-7.516 9.911-7.516 14.794 0 5.321 2.81 8.498 7.515 8.498 4.706 0 7.516-3.177 7.516-8.498 0-4.888-5.469-12.22-7.516-14.794zm0 25.292c-5.78 0-9.516-4.12-9.516-10.498 0-6.713 8.398-16.607 8.755-17.025.38-.444 1.141-.444 1.52 0 .357.418 8.756 10.312 8.756 17.025 0 6.377-3.736 10.498-9.516 10.498z",
    fill: props.color
  }));
}

export default SvgIconWaterDropFilled;